import type { LessonActivitiesFragment } from '../lesson-builder.graphql.generated';
import { DraftLessonActivities } from '../activity-builder-draft.constants';
import CsInSchoolsLogoPrint from 'approot/shared/authors/cs-in-schools-logo-print';
import { useCsInSchool } from 'approot/shared/authors/authors.hooks';
import {
  ActivityBuilderIntroFooter,
  ActivityBuilderIntroHeader,
  ActivityBuilderIntroTitlePrint,
} from './activity-builder-intro';
import * as Styled from './activity-builder-intro.style';
import { getPrintImage } from '../components/shared/logic/get-print-image';
import { LANGUAGE_CODE_EN_AU, LanguageCodes } from 'global/constants';

const ActivityBuilderIntroductionPrint = ({
  interactiveLesson,
  language,
}: {
  interactiveLesson: LessonActivitiesFragment | DraftLessonActivities;
  language?: LanguageCodes;
}) => {
  const lesson = interactiveLesson?.lesson;

  const { isCsInSchoolsLesson } = useCsInSchool(
    interactiveLesson.lesson.authorId
  );

  return (
    <Styled.IntroSlidePrint
      $backgroundImage={getPrintImage(
        interactiveLesson.landscapeImage?.responsive || null
      )}
    >
      <ActivityBuilderIntroHeader
        unitName={lesson.unit.name}
        contentName={lesson.name}
      />
      <Styled.IntroBladePrint>
        <ActivityBuilderIntroTitlePrint
          richtext={
            interactiveLesson.focusQuestion?.value ||
            interactiveLesson.phenomena?.value
          }
          logo={isCsInSchoolsLesson ? <CsInSchoolsLogoPrint /> : undefined}
        />
      </Styled.IntroBladePrint>
      <ActivityBuilderIntroFooter
        pageNumber={1}
        subject={lesson.subjects?.[0]?.label}
        showGoogleAttribution={language !== LANGUAGE_CODE_EN_AU}
      />
    </Styled.IntroSlidePrint>
  );
};

export default ActivityBuilderIntroductionPrint;
